<button
  [disabled]="disabled"
  class="button download"
  [class]="{'disabled': disabled}"
  (click)="download()">download</button>
